export default __webpack_public_path__ + "static/media/logo-mobility.a903b862.webp";